import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import PageNav from '../PageNav';
import skeletons from '../Skeletons';
import Button from '../../../../../../components/Buttons/Button';

import { format, formatQuarterYear } from '../../../../../../utils/date';

const ForecastsInsightsHeader = ({
  pending,
  activeTab,
  forecasts,
  availableKpis,
  activeForecast,
  collapsable,
  collapsed,
  headerIcon,
  viewButtontext,
  onCollapse,
  onTabChange,
}) => {
  const {
    forecast_period,
    forecast_published_at,
    bloomberg_ticker,
  } = activeForecast?.forecasts || {};

  return (
    <div className="card-box__head forecasts-header">
      <div className="card-box__head-left d-flex align-items-center">
        <h4 className="forecasts-header-heading text-bold">
          {headerIcon}
          KPI Forecasts
        </h4>
        {collapsable && collapsed && forecast_period && (
          <div className="forecasts-header-heading__stats">
              {formatQuarterYear(forecast_period)}<span className="mx-xxs">·</span>Last Published: {format(forecast_published_at, 'MMMM DD, YYYY')}
          </div>
        )}
        {!collapsable ? (pending
          ? skeletons.forecastHeader
          : (
            <PageNav
              pagesList={availableKpis || forecasts}
              active={activeTab}
              onChange={onTabChange}
            />
          )) : null}
      </div>
      <div className="card-box__head-right">
        <div className="d-flex align-items-center ml-auto">
          {collapsable && (
            <Button
              variant="secondary"
              shape="square"
              disabled={pending}
              onClick={() => onCollapse(!collapsed)}
            >
              <i className={cx(collapsed ? 'hicon-maximize' : 'hicon-minimize')} />
            </Button>
          )}
          <Button
            variant="secondary"
            href={`/my_reports?ticker=${bloomberg_ticker}&kpi_id=${activeForecast?.kpi_id}#kpi-forecasts`}
            disabled={pending}
            className="ml-xs"
          >{viewButtontext || (
            <>
              View All
              <i className="hicon-angle-right-new" />
            </>
          )}
          </Button>
        </div>
      </div>
    </div>
  );
};

ForecastsInsightsHeader.propTypes = {
  pending: T.bool.isRequired,
  activeTab: T.string,
  forecasts: T.array,
  availableKpis: T.array,
  activeForecast: T.object,
  collapsable: T.bool,
  headerIcon: T.node,
  viewButtontext: T.string,
  collapsed: T.bool,
  onCollapse: T.func,
  onTabChange: T.func.isRequired,
};

export default ForecastsInsightsHeader;
